import axios from "axios";
import { toast } from "react-toastify";

export const baseURL = () => {
  const env =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_PRODUCTION_URL
      : process.env.REACT_APP_DEV_URL;

  return env;
};

const api = axios.create({
  baseURL: `${baseURL()}api/v1`,
  // headers: {
  //   "Access-Control-Allow-Origin": "*",
  // },
});

// Response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response) {
      // Server responded with error status
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.errors?.[0]?.title ||
        error.response?.data?.error ||
        `Erro ${error.response.status}: ${error.response.statusText}`;

      toast.error(errorMessage);
    } else if (error.request) {
      // Request was made but no response received
      toast.error("Não foi possível conectar ao servidor. Tente novamente.");
    } else {
      // Something else happened
      toast.error("Erro inesperado. Tente novamente.");
    }

    // Always reject the promise so components can still handle errors if needed
    return Promise.reject(error);
  }
);

export const googleAuth = axios.create({
  baseURL: `${baseURL()}auth/google_oauth2`,
});

export const devEnv = false;

export default api;
